var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marquee',{style:({ height: `calc(${_vm.height}rem / 16)` }),attrs:{"behavior":"scroll","direction":"up","scrollamount":"3"}},_vm._l((_vm.noticeArrss),function(item,index){return _c('div',{key:`marquee_${index}`},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }